<div class="l__container">
  <section class="l__start">
    <!-- todo: dark/light logo (remove svg above)-->
    <div class="host-logo">
      @if (currentTheme == 'theme-light') {
        <img
          width="200px"
          [src]="baseUrl + '/general/logo/light'"
          alt="host-logo"
        />
      } @else if (currentTheme == 'theme-dark') {
        <img
          width="200px"
          [src]="baseUrl + '/general/logo/dark'"
          alt="host-logo"
        />
      }
    </div>

    <!-- todo: decide if app versioning should be displayed -->
    <!-- <p class="mat-caption text-muted text-center mb-0">
        {{ 'login_version' | translate }} {{ version }}
      </p> -->
  </section>

  <section class="l__middle">
    @if (loginForm) {
      <div class="login-card">
        <div class="login-card__content stack s-7">
          <div class="d-flex">
            <div class="color-scheme-section">
              <button
                mat-icon-button
                class="m3-icon-toggle-button"
                [matTooltip]="'Color_scheme_light' | translate"
                matTooltipShowDelay="1000"
                [ngClass]="{ '--selected': currentTheme === 'theme-light' }"
                (click)="themingService.setSelectedTheme('theme-light')"
              >
                <mat-icon>light_mode</mat-icon>
              </button>
              <!-- TODO: implement in theming component and add auto mode -->
              <!-- <button
                mat-icon-button
                class="m3-icon-toggle-button"
                [matTooltip]="'Color_scheme_auto' | translate"
                matTooltipShowDelay="1000"
                disabled
              >
                <mat-icon>routine</mat-icon>
              </button> -->
              <button
                mat-icon-button
                class="m3-icon-toggle-button"
                [matTooltip]="'Color_scheme_dark' | translate"
                matTooltipShowDelay="1000"
                [ngClass]="{ '--selected': currentTheme === 'theme-dark' }"
                (click)="themingService.setSelectedTheme('theme-dark')"
              >
                <mat-icon>dark_mode</mat-icon>
              </button>
            </div>
          </div>
          <div
            class="text-error text-center mb-3"
            [hidden]="!error || isLoading"
          >
            {{ error }}
          </div>
          <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
            <div class="login-card__form-fields mb-7">
              <mat-form-field>
                <mat-label>{{ 'login_email' | translate }}</mat-label>
                <input
                  matInput
                  [placeholder]="'login_email' | translate"
                  formControlName="username"
                  type="text"
                  autocomplete="username"
                  required
                />

                <!-- @if (loginForm.controls['username'].invalid &&
              loginForm.controls['username'].touched) { -->
                <mat-error>
                  {{ 'login_username_required' | translate }}
                </mat-error>
                <!-- } -->
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'login_password' | translate }}</mat-label>
                <input
                  matInput
                  [placeholder]="'login_password' | translate"
                  formControlName="password"
                  [type]="showPassword ? 'text' : 'password'"
                  autocomplete="current-password"
                  required
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="showPassword = !showPassword"
                >
                  <mat-icon>
                    {{ showPassword ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </button>
                <!-- @if (loginForm.controls['password'].invalid &&
              loginForm.controls['password'].touched) { -->
                <mat-error>
                  {{ 'login_password_required' | translate }}
                </mat-error>
                <!-- } -->
              </mat-form-field>
            </div>
            <div class="login-card__actions">
              <!-- <mat-slide-toggle color="primary" formControlName="remember" >
              {{ 'login_remember_me' | translate }}
            </mat-slide-toggle> -->
              <mat-checkbox
                class="remember-me-check"
                color="secondary"
                formControlName="remember"
                >{{ 'login_remember_me' | translate }}</mat-checkbox
              >

              <button
                mat-flat-button
                type="submit"
                [disabled]="loginForm.invalid || isLoading"
              >
                <span>{{ 'login_login' | translate }}</span>
              </button>
            </div>
          </form>
          <!-- todo: make link go somewhere -->
          <div class="mt-6">
            <div class="d-flex mb-3">
              <a
                class="link--primary mx-auto body-small"
                (click)="openResetPasswordDialog()"
                >{{ 'login_forgot_password' | translate }}</a
              >
            </div>
            <div class="d-flex">
              <a
                class="link--primary mx-auto body-small"
                (click)="openUrl(demoCourseUrl)"
                >{{ 'login_demo_url' | translate }}</a
              >
            </div>
          </div>
          @if (basicSettings) {
            <div class="d-flex mt-6">
              @if (basicSettings.imprint_url) {
                <a
                  class="link--primary mx-auto body-small"
                  href="{{ basicSettings.imprint_url }}"
                  target="_blank"
                  >{{ 'login_page.imprint_link' | translate }}</a
                >
              }
              @if (basicSettings.privacy_policy_url) {
                <a
                  class="link--primary mx-auto body-small"
                  href="{{ basicSettings.privacy_policy_url }}"
                  target="_blank"
                  >{{ 'login_page.privacy_policy_link' | translate }}</a
                >
              }
            </div>
          }
        </div>
      </div>
    }
  </section>
  <section class="l__end">
    <p class="mb-0 text-center text-muted">
      © {{ currentYear }} {{ companyName }}.
      {{ 'all_rights_reserved' | translate }}
    </p>
  </section>
</div>
